import { MenuIcon } from "@/icons";
import { Box } from "@mui/material";
import Profile from "./Profile";
import { ISession } from "@/models";
import clsx from "clsx";

type HeaderProps = {
  session: ISession | null;
  isMobile: boolean;
  isSidebarOpen: boolean;
  onToggleSidebar: () => void;
};

const Header = ({
  session,
  isMobile,
  isSidebarOpen,
  onToggleSidebar,
}: HeaderProps) => {
  return (
    <Box
      className="flex flex-row justify-between items-center header pl-2 pr-6 bg-white"
      component="header"
    >
      <Box className="flex flex-row" gap="6px">
        {isMobile ? (
          <Box
            className={clsx(
              "w-10 h-10 text-darkgreen hover:bg-[#1A5EAA] hover:text-white border-light border flex items-center justify-center rounded cursor-pointer transition-colors",
            )}
            onClick={onToggleSidebar}
          >
            <MenuIcon />
          </Box>
        ) : null}
      </Box>

      <Box className="flex flex-row items-center gap-5">
        <Profile session={session} />
      </Box>
    </Box>
  );
};
export default Header;
